import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
var __jsx = React.createElement;
import React from 'react';
import { useSelector } from 'react-redux';
import { getHasPermissions } from 'redux/selectors';
var notAllowedMessage = 'Your current role in this project does not allow you to perform this action.';
var PermissionsChecker = function PermissionsChecker(_ref) {
  var experimentId = _ref.experimentId,
    permissions = _ref.permissions,
    grayedOut = _ref.grayedOut,
    children = _ref.children,
    projectType = _ref.projectType;
  var isAuthorized = useSelector(getHasPermissions(experimentId, permissions, projectType));
  if (isAuthorized) {
    return children;
  }

  // First div is to trigger hover events
  // Second div is to disable everything under the tooltip without having to clone the children
  return __jsx(_Tooltip, {
    title: notAllowedMessage,
    mouseEnterDelay: 1
  }, __jsx("div", null, __jsx("div", {
    disabled: true,
    style: {
      pointerEvents: 'none',
      opacity: grayedOut ? 0.5 : 1
    }
  }, children)));
};
PermissionsChecker.defaultProps = {
  experimentId: null,
  grayedOut: true,
  projectType: 'experiment'
};
export default PermissionsChecker;
export { notAllowedMessage };